const routes = [
  {
    path: '/cadastro/almoxarifado/tipo-obra',
    name: 'obraType',
    component: () => import('@/views/cadastros/tipoObra/TipoObra.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Obra' }],
    },
  },
  {
    path: '/cadastro/almoxarifado/tipo-obra/novo',
    name: 'obraTypeNew',
    component: () => import('@/views/cadastros/tipoObra/TipoObraNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Obra' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/almoxarifado/tipo-obra/:id/editar',
    name: 'obraTypeUpdate',
    component: () => import('@/views/cadastros/tipoObra/TipoObraNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Almoxarifado' }, { title: 'Tipo de Obra' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/obra/tabela-de-precos',
    name: 'priceTable',
    component: () => import('@/views/cadastros/tabelaPreco/TabelaPreco.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Obra' }, { title: 'Tabela de Preços' }],
    },
  },
  {
    path: '/cadastro/obra/tabela-de-precos/novo',
    name: 'priceTableNew',
    component: () => import('@/views/cadastros/tabelaPreco/TabelaPrecoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Obra' }, { title: 'Tabela de Preços' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/obra/tabela-de-precos/:id/editar',
    name: 'priceTableUpdate',
    component: () => import('@/views/cadastros/tabelaPreco/TabelaPrecoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Obra' }, { title: 'Tabela de Preços' }, { title: 'Editar' }],
    },
  },
]

export default routes
